<template>
  <div class="rw">
    <div class="co-2">
      <div class="card mb-5">
        <div class="card-body" v-show="user.username">
          <h1 class="mb-0">{{ user.username }}'s Lists</h1>
          <p class="mt-4" v-if="user.first_name || user.last_name">{{ user.first_name }} {{ user.last_name }}</p>
        </div>
      </div>

      <div class="row mb-5" v-if="canEdit">
        <div class="col">
          <router-link :to="'/create'" class="btn btn-primary"><i class="fa fa-plus"></i> New List</router-link>
        </div>
      </div>

      <list-list :lists="lists"></list-list>
    </div>

  </div>
</template>

<script>
import ListList from '@/components/ListList'
import constants from '@/constants'

export default {

  name: 'Profile',

  components: {
    ListList
  },

  data () {
    return {
      new_list: {
        name: '',
        content_type: 'default',
        public: true,
      },
      content_type_icons: constants.content_type_icons,
      content_type_names: constants.content_type_names,
    }
  },

  created () {
    this.$store.dispatch('users/getProfile', {username: this.$route.params.username})
  },

  destroyed () {
    this.$store.dispatch('users/clearProfile')
  },

  computed: {
    user () {
      return this.$store.state.users.profile
    },
    lists () {
      return this.$store.state.lists.lists
    },
    canEdit () {
      return this.user.username === this.$store.state.users.user.username
    }
  }
}
</script>
